import html2canvas from "html2canvas";
import { onDocumentLoaded } from "../utils/on-document-loaded.js";
import { formatPrice } from "../lib/formatters.js";


const operationTypes = {
    "SALE": "ОПЛАТА",
    "REVERSAL": "ОТМЕНА ОПЛАТЫ"
};

const getCompanyTemplate = (company) => {
    if (!company) return null;

    return `
        <div class="terminal-cheque__company">
            ${company}
        </div>
    `;
};

const getBranchTemplate = (branch) => {
    if (!branch) return null;

    return `
        <div class="terminal-cheque__branch">
            ${branch}
        </div>
    `;
};

const getReceiptRow = (label, value, isMiddle = false, isBold = false) => {
    const row = [];
    const classes = [
        isBold ? "terminal-cheque__row--bold" : "",
        isMiddle ? "terminal-cheque__row--middle" : ""
    ];

    if (!label && !value) return null;

    if (label) {
        row.push(`
            <span class="terminal-cheque__label">${label}</span> 
        `);
    }

    if (value) {
        row.push(`
            <span class="terminal-cheque__value">${value}</span> 
        `);
    }

    return `
        <div class="terminal-cheque__row ${classes.join(" ")}">
            ${row.join("")}
        </div>
    `;
};

const getGroup = (children, isGrey = false) => {
    if (!children) return null;

    const additionalClass = isGrey ? "terminal-cheque__group--grey" : "";

    return `
        <div class="terminal-cheque__group ${additionalClass}">
            ${children.join("")}
        </div>
    `;
};

const zeroBeforeNum = (num) => {
    if (num < 9) {
        return `0${num}`;
    }

    return num;
};

const getTime = (date) => {
    const newDate = new Date(date);
    const hh = newDate.getHours();
    const mm = newDate.getMinutes();
    const ss = newDate.getSeconds();

    const time = `${zeroBeforeNum(hh)}:${zeroBeforeNum(mm)}:${zeroBeforeNum(ss)}`;

    return time;
};

const getDate = (date, withTime = false) => {
    const newDate = new Date(date);
    const day = newDate.getDate();
    const formattedDate = `${zeroBeforeNum(day)}/${zeroBeforeNum(newDate.getMonth() + 1)}/${newDate.getFullYear()}`;
    const time = getTime(date);

    if (withTime) {
        return `${formattedDate} ${time}`;
    }

    return formattedDate;
};


onDocumentLoaded(async (e) => {
    const errorEl = document.querySelector("[data-msg='error']");
    const no_uid = document.querySelector("[data-msg='no_uid']");
    const root = document.querySelector(".terminal-cheque__container-inner");
    const rootHeader = document.querySelector(".terminal-cheque__header");
    const rootBody = document.querySelector(".terminal-cheque__body");
    const loader = document.querySelector(".terminal-cheque__loader");
    const btn = document.querySelector(".terminal-cheque__btn");

    const params = new URLSearchParams(location.search);
    const isDev = !!params.get("dev");
    const baseUrl = isDev ? "https://api-dev.smartpos.uz" : "https://api.smartpos.uz";
    const pathnameParts = location.pathname.split("/").filter(Boolean);
    const uid = pathnameParts[pathnameParts.length - 1];

    console.log(pathnameParts, "uid");

    if (uid === "terminal_cheque") {
        no_uid.classList.remove("d-none");

        return;
    }

    loader.classList.remove("d-none");

    try {
        const response = await fetch(`${baseUrl}/api/public/transaction/${uid}`);
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data?.detail);
        }

        root.classList.remove("d-none");

        const receiptNumber = (data.info?.bddn && data.info?.sequenceNumber) ? `${data.info?.bddn}/${data.info?.sequenceNumber}` : "";
        const amount = data.amount ? `${formatPrice(Number(data.amount))} ${data.currency}` : "";

        const test = data.amount.toFixed(2);

        console.log(data.dateTime);

        const head = [
            getCompanyTemplate(data.company?.name), // название компании
            getBranchTemplate(data.info?.otcAddress), // адрес
        ];
        const body = [
            getGroup([
                getReceiptRow("Терминал", data.info?.terminalId ?? "-"), // id терминала
                getReceiptRow("Продавец", data.info?.merchantId ?? "-"), // id продавца
            ]),
            getGroup([
                getReceiptRow(data.info?.paymentSystemType), // тип платежной системы
                getReceiptRow(`Чек:`, receiptNumber || "-"), // чек
            ]),
            getGroup([
                getReceiptRow(operationTypes[data.operation] ?? data.operation, "", true, true), // тип операции
                getReceiptRow(getDate(data.dateTime), getTime(data.dateTime)), // чек
                getReceiptRow("Сумма:", amount, false, true), // сумма
                getReceiptRow("Номер карты:", data.info?.cardNumber), // номер карты
            ]),
            getGroup([
                getReceiptRow("AID", data.info?.emvName ?? "-"), // aid
                getReceiptRow("RRN:", data.info?.rrn ?? "-"), // rrn
                getReceiptRow("Код:", data.info?.resultCode ?? "-"), // код
                getReceiptRow(data.info?.statusMessage, "", true, true), // статус операции
            ])
        ];

        rootHeader.insertAdjacentHTML("beforeend", head.join(""));
        rootBody.insertAdjacentHTML("beforeend", body.join(""));

        html2canvas(root.children[0]).then((canvas) => {
            const data = canvas.toDataURL("image/png;base64");

            btn.download = "terminal-cheque";
            btn.href = data;
        });

    } catch(e) {
        const message = e.message;

        if (message) {
            errorEl.textContent = e.message;
        }

        errorEl.classList.remove("d-none");
    } finally {
        loader.classList.add("d-none");
    }
});